import {
  useGetDemoQuery,
  useGetWorkspaceQuery,
  useLazyGetFolderQuery,
} from '@carboncopyco/data';
import { Breadcrumbs } from '@carboncopyco/ui';
import { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDemoOrOverlayProps } from './useDemoOrOverlayProps';

export const DemoOrOverlayPageBreadcrumbs = () => {
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const { organizationId, demoId } = useDemoOrOverlayProps();
  const { data: workspace } = useGetWorkspaceQuery({
    organizationId: organizationId,
    id: workspaceId,
  });
  const { data: demo } = useGetDemoQuery({
    organizationId,
    workspaceId,
    id: demoId,
  });
  const [getFolder, { data: folder }] = useLazyGetFolderQuery();

  const links = useMemo(
    () => [
      {
        label: workspace?.workspaceName,
        onClick: () => navigate(`/${organizationId}/workspace/${workspaceId}`),
      },
    ],
    [navigate, organizationId, workspace?.workspaceName, workspaceId]
  );

  useEffect(() => {
    if (demo?.folderId) {
      getFolder({
        organizationId,
        workspaceId,
        folderId: demo.folderId,
      });
    }
  }, [demo, getFolder, workspaceId, organizationId]);

  const getDemoPageLinks = useMemo(() => {
    if (folder && demo.folderId) {
      return [
        ...links,
        {
          label: folder?.name,
          onClick: () =>
            navigate(
              `/${organizationId}/workspace/${workspaceId}/folder/${demo.folderId}`
            ),
        },
      ];
    }
    return links;
  }, [folder, demo?.folderId, links, navigate, organizationId, workspaceId]);

  return (
    <Breadcrumbs
      current={demo?.demoName}
      links={getDemoPageLinks}
    />
  );
};
